import {imageOff} from 'cl-icons';
import React from 'react';
import _ from 'lodash';
import URI from 'urijs';
import {store} from 'crazyEditor/redux/store';
import CustomSvgIconNew from '../../../crazyEditor/components/EditorUI/BaseUI/CustomSvgIcon/CustomSvgIconNew';
import ReactDOMServer from 'react-dom/server';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {grey} from '@material-ui/core/colors';

export function isCrazylisterHostedImage(url) {
  return _.isString(url) && url.indexOf('crazylister.com/') !== -1;
}

export function isEbayImage(url) {
  return url.indexOf('i.ebayimg.com') !== -1;
}

export function cLencodeURIcomponent(url) {
  if (!isCrazylisterHostedImage(url)) {
    return url;
  }
  return url.replace(/&pid=.*/, '').replace(/ /g, '%20').replace(/&/g, '%26').replace(/\+/g, '%2B').replace(/#/g, '%23').replace(/@/g, '%40').replace(/'/g, '%27');
}

export function encodeURIForLambda(url) {
  const uri = URI(url);
  const splitPath = uri.pathname().split('/');
  _.forEach(splitPath, pathSection => {
    if (isEbayImage(url)) {
      url = _.replace(url, `/${pathSection}`, `/${encodeURI(decodeURI(pathSection))}`);
    } else {
      url = _.replace(url, `/${pathSection}`, `/${encodeURIComponent(decodeURIComponent(pathSection))}`);
    }
  });
  return url;
}

export function getEbayHighResUrl(url) {
  if (url.indexOf('.ebayimg.com') !== -1) {
    url = _.replace(url, '/^http:/i', 'https:');
  }
  if (url.indexOf('i.ebayimg.com') !== -1) {
    const splitUrl = _.split(url, '/');
    if (!_.isEmpty(splitUrl[6]) && splitUrl[6] === 'z') {
      return 'https://i.ebayimg.com/images/g/' + splitUrl[_.size(splitUrl) - 2] + '/s-l1600.' + _.toLower(URI(url).suffix());
    }
  }
  return url;
}

export function getResizeUrl(url, size, highResImage = false) {
  if (!_.isString(url) || (!isCrazylisterHostedImage(url) && !isEbayImage(url))) {
    return url;
  }
  if (highResImage && isEbayImage(url)) {
    return getEbayHighResUrl(url);
  }
  if (URI(url).suffix() === 'svg' || size.height > 4500 || size.width > 4500) {
    return url;
  }
  let resizeUrl = 'https://resized-images.crazylister.com/';
  resizeUrl += Buffer(encodeURIForLambda(url), 'utf8').toString('hex');
  if (size.height) {
    resizeUrl += `/auto/${size.height }`;
  } else if (size.width) {
    resizeUrl += `/${size.width}/auto`;
  } else {
    console.warn('Requested resize url but no size given');
    return url;
  }
  resizeUrl += `.${URI(url).suffix()}`;
  return resizeUrl;
}

export function getResizeUrlByUserPreference(url, size, highResImage = false) {
  if (store.getState().general.optimizeImageSize) {
    return getResizeUrl(url, size, highResImage);
  }
  return url;
}

const muiTheme = getMuiTheme();
export function getImageDataUrlFromIcon(icon) {
  return `data:image/svg+xml;utf8,${ReactDOMServer.renderToStaticMarkup(
    <MuiThemeProvider muiTheme={muiTheme}>
      {icon}
    </MuiThemeProvider>)}`;
}

export function getImageDataUrlFromPath(path, color = undefined) {
  return getImageDataUrlFromIcon(<CustomSvgIconNew color = {color} xmlns="http://www.w3.org/2000/svg" path={path}/>);
}

// TODO - write this tsx style / can't we make the general behavior part of Img.tsx?
export function getImageFallbackComponent(size, backgroundSize = size / 2) {
  return (<div style = {{
    height: size,
    width: size,
    backgroundColor: grey[400],
    backgroundRepeat: 'no-repeat',
    backgroundSize: backgroundSize,
    backgroundPosition: 'center',
    backgroundImage: `url('${getImageDataUrlFromPath(imageOff, '#ffffff')}')`}}/>); // MUI doesn't have white color for some reason
}
